import { stable } from '../data/stable';
import { Lang } from '../types/content';

/** Link to the SimplyBook.me booking page in the site language, optionally opened on one ride. */
export function simplyBookUrl(lang: Lang, serviceId?: string): string | null {
  if (!stable.simplyBookUrl) return null;
  const base = stable.simplyBookUrl.replace(/\/$/, '');
  const hash = serviceId ? `#book/service/${serviceId}/count/1/` : '';
  return `${base}/v2/?lang=${lang}${hash}`;
}
